import { IRootState } from "../../store";

export const selectNotifications = (state: IRootState) =>
  state.notifications.notifications;
